// extracted by mini-css-extract-plugin
export default {"content":"emailmodal_content__XBIXp","text":"emailmodal_text__Xhecv"};